import React from 'react';
import styled from 'styled-components';

import { callNativeMethod } from 'src/mobile-ecomm/hooks/use-mobile-native-bridge';
import useTranslation from 'hooks/use-translation';

export function DeleteAccountLink(): JSX.Element {
  const { t } = useTranslation();

  return (
    <StyledDeleteAccountLink type='button' onClick={() => callNativeMethod(`onLaunchDeleteAccountModal`)}>
      {t('common.save', 'Delete your Dutchie Account')}
    </StyledDeleteAccountLink>
  );
}

const StyledDeleteAccountLink = styled.button`
  appearance: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.grey[25]};
`;
